import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import Moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import '../App.css';
import environment from '../environments/environment';
import Pagination from '../Pagination';
import PagerService from '../Services/PagerService';
import * as constants from '../Constants';

const mapStateToProps = (state) => {
    return {
        userStatus: state.lognReducer
    }
}

class ViewMetricks extends React.Component {
    constructor() {
        super();
        this.state = {
            show: false,
            caseList: [],
            reDirect: '',
            id: 0,
            attorney: '',
            supervisor: '',
            statusFlag: "All",
            status: constants.IS_ACTIVE_YES,
            pageSize: '',
            totalItems: '',
            //pager object
            pager: {},
            // paged items
            pagedItems: [],
            //searchFlag: false,
            metrickListCount: '',
            supervisors: [],
            attorneys: [],
            email: '',
            userRole: '',
            reportStartDate: new Date(),
            reportEndDate: new Date(),
            attorneyId: -1,
            caseId: -1,
            supervisorId: -1,
            caseName: "",
            toDayDate: new Date(),
            metrickList: []
        }
        this.onRenderDayCell = this.onRenderDayCell.bind(this);
    }
    componentDidMount = async () => {
        let startDate = "01/01/" + this.state.reportEndDate.getFullYear();
        // const timestamp = Date.now(); // This would be the timestamp you want to format
        if (this.props.userStatus.userName !== "") {
            this.setState({
                reportStartDate: startDate,
                pageSize: this.toSetPagination(),
                email: this.props.userStatus.emailId,
                userRole: this.props.userStatus.userRole,
                supervisorId: this.props.userStatus.userRole === 'Admin' ? -1 : this.props.userStatus.parentId > 0 ? this.props.userStatus.parentId : this.props.userStatus.userId,
                supervisor: this.props.userStatus.userRole === 'Admin' ? '' : this.props.userStatus.userName,
                attorneyId: this.props.userStatus.userRole === 'Admin' ? -1 : this.props.userStatus.parentId > 0 ? this.props.userStatus.userId : -1,
                attorney: this.props.userStatus.userRole === 'Admin' ? '' : this.props.userStatus.parentId > 0 ? this.props.userStatus.userName : ''
            }, () => {
                axios.get(environment.getAllSupervisors)
                    .then(response => {
                        if (response.data !== null) {
                            this.setState({
                                supervisors: response.data,
                            });
                            if (this.state.supervisorId > 0) {
                                let supervisor;
                                for (let i = 0; i < this.state.supervisors.length; i++) {
                                    if (this.state.supervisorId === this.state.supervisors[i].supervisorId) {
                                        supervisor = this.state.supervisors[i].supervisor;
                                    }
                                }
                                this.setState({
                                    ...this.state,
                                    supervisor: supervisor
                                });
                                this.getAttorney(this.state.supervisorId);
                            }
                        }
                    })
                this.setPage(1);
            })

        } else {
            this.setState({
                reDirect: '/',
            })
        }
    }

    getAttorney(value) {
        axios.get(environment.getAllAttorneys + value)
            .then(response => {
                if (response.data !== null) {
                    this.setState({
                        attorneys: response.data,

                    });
                }
            })
    }
    onDateFocusOut(event) {
        if (event.target.value !== '') {
            let data = new Date(event.target.value);
            this.setState({
                ...this.state,
                [event.target.name]: data,
            })
        }
    }
    changeValue = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }, () => {
            if (e.target.name === 'caseName') {
                if (this.state.caseName !== "") {
                    let caseId;
                    for (let i = 0; i < this.state.caseList.length; i++) {
                        if (this.state.caseName === this.state.caseList[i].caseName) {
                            caseId = this.state.caseList[i].caseId;
                        }
                    }
                    this.setState({
                        ...this.state,
                        caseId: caseId
                    }, () => {
                        this.setPage(1);
                    });
                } else {
                    this.setState({
                        ...this.state,
                        caseId: -1
                    }, () => {
                        this.setPage(1);
                    });
                }
            }
            if (e.target.name === 'attorney') {
                if (this.state.attorney !== "") {
                    let attorneyId;
                    for (let i = 0; i < this.state.attorneys.length; i++) {
                        if (this.state.attorney === this.state.attorneys[i].attorneyName) {
                            attorneyId = this.state.attorneys[i].attorneyId;
                        }
                    }
                    this.setState({
                        ...this.state,
                        attorneyId: attorneyId,
                        caseId: -1,
                        caseList: [],
                        caseName: ""
                    }, () => {
                        this.getCases();
                        this.setPage(1);
                    })
                } else {
                    this.setState({
                        ...this.state,
                        attorneyId: -1,
                        caseId: -1,
                        caseList: [],
                        caseName: ""
                    }, () => {
                        this.setPage(1);
                    })
                }
            }
            if (e.target.name === 'supervisor') {
                if (this.state.supervisor !== "") {
                    let supervisor;
                    for (let i = 0; i < this.state.supervisors.length; i++) {
                        if (this.state.supervisor === this.state.supervisors[i].supervisor) {
                            supervisor = this.state.supervisors[i].supervisorId;
                        }
                    }
                    this.setState({
                        ...this.state,
                        supervisorId: supervisor,
                        caseList: [],
                        attorneyId: -1,
                        caseId: -1,
                    }, () => {
                        this.getAttorney(this.state.supervisorId);
                        this.setPage(1);
                    })
                } else {
                    this.setState({
                        ...this.state,
                        supervisorId: -1,
                        attorneyId: -1,
                        caseId: -1,
                        attorneys: [],
                        caseList: [],
                        caseName: "",
                        attorney: "",
                    }, () => {
                        this.setPage(1);
                    })
                }
            }
        });
    }
    search = e => {
        e.preventDefault();
        this.setPage(1);
    }

    clear = e => {
        e.preventDefault();
        this.setState({
            reportStartDate: "02/01/" + this.state.reportEndDate.getFullYear(),
            reportEndDate: new Date(),
            attorneyId: -1,
            supervisorId: -1,
            caseId: -1,
            supervisor: "",
            attorney: "",
            caseName: "",
            attorneys: [],
            caseList: []
        }, () => {
            this.setPage(1);
        })
    }

    toSetPagination() {
        let pageSize = 0;
        if (localStorage.getItem("listingPageSize") != null &&
            localStorage.getItem("listingPageSize") !== undefined && localStorage.getItem("listingPageSize") !== '0') {
            let tempstr = localStorage.getItem("listingPageSize");
            pageSize = parseInt(tempstr);
        }
        else {
            pageSize = 5;
        }
        return pageSize;
    }

    onPageNoChanged = (pageNo) => {
        this.setPage(pageNo);
    }

    pageSizeChanged = (pageSize) => {
        this.setState({
            pageSize: pageSize
        }, () => {
            this.setPage(1);
            localStorage.setItem('listingPageSize', pageSize);
        })
    }

    setPage(page) {
        this.getCasesMetricList(page, this.state.pageSize);
    }

    getCasesMetricList(page, pageSize) {
        let CasesMetricSearchVO = {};
        CasesMetricSearchVO.pageNo = -1;
        CasesMetricSearchVO.pageSize = -1;
        CasesMetricSearchVO.supervisors = this.state.supervisorId;
        CasesMetricSearchVO.attorney = this.state.attorneyId;
        CasesMetricSearchVO.cases = this.state.caseId;
        CasesMetricSearchVO.reportStartDate = Moment(this.state.reportStartDate).format('MM/DD/YYYY');
        CasesMetricSearchVO.reportEndDate = Moment(this.state.reportEndDate).format('MM/DD/YYYY');
        CasesMetricSearchVO.userName = this.props.userStatus.emailId;
        axios.post(environment.getCasesMetricCount, CasesMetricSearchVO)
            .then(response => {
                if (response.data !== undefined && response.data !== null) {
                    this.setState({
                        ...this.state,
                        metrickListCount: response.data
                    }, () => {
                        CasesMetricSearchVO.pageNo = page;
                        CasesMetricSearchVO.pageSize = pageSize;
                        if (this.state.metrickListCount !== 0) {
                            axios.post(environment.getCasesMetricList, CasesMetricSearchVO)
                                .then(response => {
                                    if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                                        this.setState({
                                            ...this.state,
                                            metrickList: response.data.caseMetricInfoVO
                                        }, () => {
                                            this.setState({
                                                pageSize: this.toSetPagination(),
                                                pager: PagerService.getPager(
                                                    this.state.metrickListCount,
                                                    page,
                                                    this.state.pageSize
                                                ),
                                                totalItems: this.state.metrickListCount,
                                                pagedItems: this.state.metrickList.slice(
                                                    0,
                                                    this.state.pageSize
                                                )
                                            });

                                        });
                                    } else {
                                        toast.error(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER });
                                    }
                                }).catch((error) => {
                                    toast.error(error.message, { position: toast.POSITION.TOP_CENTER });
                                });
                        } else {
                            this.setState({
                                totalItems: 0,
                                metrickList: null,
                                pagedItems: null
                            })
                        }

                    });
                } else {
                    toast.error(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER });
                }
            }).catch((error) => {
                toast.error(error.message, { position: toast.POSITION.TOP_CENTER });
            });
    }

    onCancelChanges() {
        this.setState({
            reDirect: "/caseSummary"
        })
    }
    onRemindModal() {
        this.setState({ shows: false });
    };
    showRemindModal = (caseId) => {
        this.setState({
            caseId: caseId, shows: true
        });
    };
    onSubmitChanges() {
        this.toReminder();
    }

    getCases() {
        let casesearch = {};
        casesearch.attorneyName = this.state.attorney;
        casesearch.supervisor = this.state.supervisor;
        casesearch.attorneyId = this.state.attorneyId;
        casesearch.supervisorId = this.state.supervisorId;
        casesearch.statusFlag = this.state.statusFlag;
        casesearch.status = this.state.status;
        casesearch.mailId = this.props.userStatus.emailId;
        casesearch.userRole = this.props.userStatus.userRole;
        casesearch.pageNo = -1;
        casesearch.pageSize = -1;
        axios.post(environment.getCaseInfoList, casesearch)
            .then(response => {
                if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                    this.setState({
                        ...this.state,
                        caseList: response.data.caseVOList
                    });
                }
            }
            ).catch((error) => {
                toast.error(error.message, { position: toast.POSITION.TOP_CENTER });
            });
    }

    toCaseDetails(event, caseId) {
        event.preventDefault();
        this.setState({
            caseId: caseId,
            pageName: "CaseMetrics",
            reDirect: '/caseDetails'
        })
    }
    onRenderDayCell(args) {
        if (this.state.toDayDate !== null) {
            if (this.state.lastReportSent !== null) {
                if ((args.date > this.state.toDayDate)) {
                    // sets isDisabled to true to disable the date.
                    args.isDisabled = true;
                }
            }
        }
    }
    render() {
        if (this.state.reDirect) {
            return <Redirect
                to={{
                    pathname: this.state.reDirect, state: {
                        caseId: this.state.caseId,
                        pageName: this.state.pageName,
                    }
                }} />
        }

        return (
            <section style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                <div className="container mt-2 ">
                    <h4>Case Metrics</h4>
                    <div className="row mb15 mr-2" style={{ marginTop: ' 15px' }}>

                        <div className="col-4 pl-0 pr-0">
                            <label className="col  ">Supervisor</label>&nbsp;
                            <select name="supervisor" value={this.state.supervisor} onChange={this.changeValue}  >
                                <option value="">All</option>
                                {this.state.supervisors.map((supervisor) => (
                                    <option key={supervisor.supervisorId} value={supervisor.supervisor}
                                    >{supervisor.supervisor}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-4 ">
                            <label className="col-2  pl-0">Attorney </label>&nbsp;
                            <select className="col-5" name="attorney" value={this.state.attorney} onChange={this.changeValue}  >
                                <option value="">All</option>
                                {this.state.attorneys.map((attorney) => (
                                    <option key={attorney.attorneyId} value={attorney.attorneyName}
                                    >{attorney.attorneyName}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-4 ">
                            <label className="col-2  pl-0">Case</label>&nbsp;
                            <select className="col-5" name="caseName" value={this.state.caseName} onChange={this.changeValue}  >
                                <option value="" >All</option>
                                {this.state.caseList !== undefined && this.state.caseList !== null && this.state.caseList.map((caseVo) => (
                                    <option key={caseVo.caseId} value={caseVo.caseName}
                                    >{caseVo.caseName}</option>
                                ))}
                            </select>
                        </div>
                        <label style={{ width: '10%', paddingRight: '0%' }} className="mt-3"> Start Date
                        </label>
                        <div style={{ width: '15%', paddingLeft: '1%', marginLeft: '-3%' }} className="mt-3">
                            <DatePickerComponent id="reportStartDate" name="reportStartDate" className="form-control" allowEdit={true} showTodayButton={false}
                                value={this.state.reportStartDate !== '' ? (Moment(this.state.reportStartDate).format('MM-DD-yyyy')) : (this.state.reportStartDate)} format='MM-dd-yyyy' onChange={this.changeValue}
                                renderDayCell={this.onRenderDayCell} onBlur={(event) => this.onDateFocusOut(event)}></DatePickerComponent>
                        </div>
                        <label style={{ width: '10%', marginLeft: '8%', paddingLeft: '4%', paddingRight: '0%' }} className="mt-3">End Date</label>
                        <div style={{ width: '14%', paddingLeft: '0px' }} className="mt-3">
                            <DatePickerComponent id="reportEndDate" name="reportEndDate" className="form-control " allowEdit={true} showTodayButton={false}
                                value={this.state.reportEndDate !== '' ? (Moment(this.state.reportEndDate).format('MM-DD-yyyy')) : (this.state.reportEndDate)} format='MM-dd-yyyy'
                                renderDayCell={this.onRenderDayCell} onChange={this.changeValue} onBlur={(event) => this.onDateFocusOut(event)}></DatePickerComponent>
                        </div>
                    </div>

                    <div className="row mb-2 mt-2">
                        <div className="col-md-6 mr-auto text-left">
                            <Link onClick={this.search}><span
                                className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Search</span></Link>
                            <Link onClick={this.clear}><span
                                className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Clear</span> </Link>
                            {/* <Link to="/documents"><span
                                className="btn  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6' }}>Remind all</span> </Link> */}
                        </div>
                    </div>

                    <div className="table-responsive dashboard ">
                        <table className="table table-bordered table-condensed table-striped table-hover table-sm"
                            id="table-dashboard">
                            <thead className="color">
                                <tr style={{ borderStyle: 'hidden' }}>
                                    <th>Case</th>
                                    <th>Case Supervisor</th>
                                    <th>Attorney </th>
                                    <th style={{ textAlign: 'center' }} >Due Date</th>
                                    <th style={{ textAlign: 'center' }}>Number of days delayed</th>
                                </tr>
                            </thead>
                            <tbody style={{ borderStyle: 'hidden' }}  >
                                {this.state.pagedItems != null && this.state.pagedItems.map((cases, index) => (
                                    <tr key={index}>
                                        <td><Link onClick={(event) => this.toCaseDetails(event, cases.caseId)}>{cases.caseName}</Link></td>
                                        <td >{cases.supervisor}</td>
                                        <td>{cases.attorney}</td>
                                        <td align="center">{Moment(cases.report_due_date).format('MM/DD/YYYY')}</td>
                                        <td align="center" >{cases.noOfDaysDelay}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {this.state.totalItems === 0 && <p> No Records are Found.</p>}
                    {this.state.pagedItems !== undefined && this.state.totalItems > 5 && <Pagination pager={this.state.pager} setPage={this.onPageNoChanged} setPageSize={this.pageSizeChanged}></Pagination>}
                    <ToastContainer style={{ marginTop: '7%' }} />

                </div >
            </section >
        )
    }

}
export default connect(mapStateToProps)(ViewMetricks);